var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var MagicWand = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M19.3479 12.01V16.5151M17.096 14.2625H21.5999M6.96213 3.7505V7.5048M5.0855 5.62765H8.83877M14.844 17.266V20.2694M13.3427 18.7677H16.3453M12.592 7.5048L15.5947 10.5082M2.61976 17.4853L16.573 3.52823C16.8661 3.235 17.3414 3.235 17.6346 3.52823L19.5753 5.46947C19.8684 5.7627 19.8684 6.23812 19.5753 6.53134L5.62206 20.4884C5.32891 20.7816 4.85362 20.7816 4.56048 20.4884L2.61976 18.5471C2.32662 18.2539 2.32662 17.7785 2.61976 17.4853Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
